export const CATEGORIES_LOOKUP_REQUEST = "CATEGORIES_LOOKUP_REQUEST";
export const CATEGORIES_LOOKUP_RESPONSE =
  "CATEGORIES_LOOKUP_RESPONSE";

export const SUB_CATEGORIES_LOOKUP_REQUEST =
  "SUB_CATEGORIES_LOOKUP_REQUEST";
export const SUB_CATEGORIES_LOOKUP_RESPONSE =
  "SUB_CATEGORIES_LOOKUP_RESPONSE";

export const COUNTRIES_LOOKUP_REQUEST = "COUNTRIES_LOOKUP_REQUEST";
export const COUNTRIES_LOOKUP_RESPONSE = "COUNTRIES_LOOKUP_RESPONSE";

export const EXPORTERS_LOOKUP_REQUEST = "EXPORTERS_LOOKUP_REQUEST";
export const EXPORTERS_LOOKUP_RESPONSE = "EXPORTERS_LOOKUP_RESPONSE";

export const COMPANIES_LOOKUP_REQUEST = "COMPANIES_LOOKUP_REQUEST";
export const COMPANIES_LOOKUP_RESPONSE = "COMPANIES_LOOKUP_RESPONSE";

export const BUSINESS_VERIFICATION_TYPES_LOOKUP_REQUEST =
  "BUSINESS_VERIFICATION_TYPES_LOOKUP_REQUEST";
export const BUSINESS_VERIFICATION_TYPES_LOOKUP_RESPONSE =
  "BUSINESS_VERIFICATION_TYPES_LOOKUP_RESPONSE";

export const BUSINESS_TYPES_LOOKUP_REQUEST =
  "BUSINESS_TYPES_LOOKUP_REQUEST";
export const BUSINESS_TYPES_LOOKUP_RESPONSE =
  "BUSINESS_TYPES_LOOKUP_RESPONSE";

export const BUSINESS_VERIFICATION_STATUS_LOOKUP_REQUEST =
  "BUSINESS_VERIFICATION_STATUS_LOOKUP_REQUEST";
export const BUSINESS_VERIFICATION_STATUS_LOOKUP_RESPONSE =
  "BUSINESS_VERIFICATION_STATUS_LOOKUP_RESPONSE";

export const VOUCHER_COMPANIES_LOOKUP_REQUEST =
  "VOUCHER_COMPANIES_LOOKUP_REQUEST";
export const VOUCHER_COMPANIES_LOOKUP_RESPONSE =
  "VOUCHER_COMPANIES_LOOKUP_RESPONSE";

export const TRANSACTION_PAYMENT_REASONS_LOOKUP_REQUEST =
  "TRANSACTION_PAYMENT_REASONS_LOOKUP_REQUEST";
export const TRANSACTION_PAYMENT_REASONS_LOOKUP_RESPONSE =
  "TRANSACTION_PAYMENT_REASONS_LOOKUP_RESPONSE";
export const TRANSACTION_STATUS_LOOKUP_REQUEST =
  "TRANSACTION_STATUS_LOOKUP_REQUEST";
export const TRANSACTION_STATUS_LOOKUP_RESPONSE =
  "TRANSACTION_STATUS_LOOKUP_RESPONSE";

export const ROLES_LOOKUP_REQUEST = "ROLES_LOOKUP_REQUEST";
export const ROLES_LOOKUP_RESPONSE = "ROLES_LOOKUP_RESPONSE";

export const PRICING_PLANS_LOOKUP_REQUEST =
  "PRICING_PLANS_LOOKUP_REQUEST";
export const PRICING_PLANS_LOOKUP_RESPONSE =
  "PRICING_PLANS_LOOKUP_RESPONSE";
